import { render, staticRenderFns } from "./BlackPackages.vue?vue&type=template&id=3abff348&"
import script from "./BlackPackages.vue?vue&type=script&lang=js&"
export * from "./BlackPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports